/* Safara Aroma 2.0: glass header, motion and small interface details. */
(function () {
  'use strict';
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header: compact glass once the page scrolls. */
  var header = document.querySelector('[data-header]');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var setH = function () { document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); };
    setH();
    window.addEventListener('resize', setH);
  }

  /* Navigation: a frosted pill glides to the tab you point at or open. */
  $$('[data-glass-nav]').forEach(function (list) {
    var pill = list.querySelector('.main-nav__pill');
    if (!pill) return;
    var items = $$('.main-nav__item', list);
    function moveTo(item) {
      if (!item) { pill.classList.remove('is-on'); return; }
      var link = item.querySelector('.main-nav__link');
      var lr = list.getBoundingClientRect(), r = link.getBoundingClientRect();
      pill.style.setProperty('--x', (r.left - lr.left) + 'px');
      pill.style.setProperty('--w', r.width + 'px');
      pill.classList.add('is-on');
    }
    var current = items.filter(function (i) { return i.classList.contains('is-active'); })[0] || null;
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { moveTo(item); });
      item.addEventListener('focusin', function () { moveTo(item); });
      item.addEventListener('click', function () { current = item; });
    });
    list.addEventListener('mouseleave', function () { moveTo(current); });
    if (current) requestAnimationFrame(function () { moveTo(current); });
  });

  /* Pointer-following light on glass surfaces. */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointermove', function (e) {
      var g = e.target.closest && e.target.closest('.glass-sheen, .main-nav__pill, .ai-bar, .concierge__panel, .glass-panel');
      if (!g) return;
      var r = g.getBoundingClientRect();
      g.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      g.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* AI bar: rotate example prompts so shoppers know they can talk to it. */
  $$('[data-ai-prompts]').forEach(function (input) {
    var raw = input.getAttribute('data-ai-prompts') || '';
    var prompts = raw.split(/<br\s*\/?>/i).map(function (s) { return s.trim(); }).filter(Boolean);
    if (prompts.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      if (document.activeElement === input || input.value) return;
      i = (i + 1) % prompts.length;
      input.classList.add('is-swapping');
      setTimeout(function () { input.setAttribute('placeholder', prompts[i]); input.classList.remove('is-swapping'); }, 220);
    }, 3800);
  });

  /* Account pop-over. */
  $$('[data-account-pop]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-account-toggle]');
    var panel = wrap.querySelector('.account-pop__panel');
    function set(open) { panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); wrap.classList.toggle('is-open', open); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); set(panel.hidden); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  });

  /* Gentle reveal for home page sections and cards. */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-reveal-up]').forEach(function (el) { el.classList.add('will-reveal'); io.observe(el); });
  }

  /* Category circles: drag to scroll on desktop. */
  $$('[data-drag-scroll]').forEach(function (track) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; track.classList.add('is-dragging'); });
    window.addEventListener('pointerup', function () { down = false; track.classList.remove('is-dragging'); });
    track.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startLeft - dx; });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* Footer columns fold away on phones. */
  $$('[data-footer-fold]').forEach(function (d) {
    var mq = window.matchMedia('(min-width: 750px)');
    var sync = function () { if (mq.matches) d.setAttribute('open', ''); else d.removeAttribute('open'); };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
  });
})();
